import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Slides from '@ifeng-fe/ui_pc_slides';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const sliderTmpl = item => (
            <div className={styles.li}>
                <a className={styles.blockA} href={item.url} target="_blank" rel={rel}>
                    <img src={item.thumbnails} style={{ width: '100%', height: 472 }} />
                </a>
                <div className={styles.list}>
                    <h3>
                        <a className={styles.title} href={item.url} target="_blank" rel={rel}>
                            {item.title}
                        </a>
                    </h3>
                    <p className={styles.summary}>{item.summary}</p>
                </div>
            </div>
        );

        const sliderConfig = {
            arrows: true,
            dots: true,
            dotsAction: 'click',
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 5000,
            axis: 'horizonta',
            initialSlide: 0,
            unitSize: 1000,
            speed: 500,
            infinite: true,
            extension: 2,
            padding: 1,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl,
        };

        return (
            <div className={styles.sliderContainer}>
                <div className={styles.sliderWraper}>
                    <Slides content={content} config={sliderConfig} />
                </div>
            </div>
        );
    }
}
export default errorBoundary(Banner);
